// extracted by mini-css-extract-plugin
export var desktop_nav = "NavItems-module--desktop_nav--xE6LN";
export var donate_btn = "NavItems-module--donate_btn--3aDhd";